import * as Sentry from '@sentry/react'
import dayjs from 'dayjs'

import { getLocalStorageValue } from '../hooks/use-local-storage'

import type { TAppsflyerEvent } from './appsflyer-events'
import type { TData } from './types'

type GlobalWithAF = typeof globalThis & {
    AF?: (command: string, type: string, payload: Record<string, unknown>) => void
    AppsFlyerSdkObject?: string
}

export const sendAppsflyer = (event: TAppsflyerEvent, params: TData): void => {
    try {
        const win = globalThis as GlobalWithAF

        const env = __GLOBAL__.VITE_API_URL

        const uid = getLocalStorageValue('user-id', '')
        const cid = getLocalStorageValue('user-cid', '')

        // Формируем параметры события для AppsFlyer
        const eventValues: Record<string, unknown> = {
            event_time: dayjs().format('HH:mm:ss, DD.MM.YYYY'),
            appsflyer_id: 'appsflyer_id',
            app_version: 'app_version',
            platform: 'platform',
            city_id: cid,
            user_id: uid,
            ...params,
        }

        const payload = {
            eventName: event,
            eventType: 'EVENT',
            eventValue: eventValues,
        }

        if (eventValues) {
            payload.eventValue = eventValues
        }

        if (typeof win?.AF === 'function') {
            win.AF('pba', 'event', payload)

            if (env.includes('dev')) {
                console.log('AF Event отправлен:', event, JSON.stringify(eventValues, null, 2))
            }
        }
    } catch (error) {
        Sentry.captureException(error, {
            tags: {
                errorType: 'appsflyer-send-event',
            },
        })
    }
}
